import { createContext, useState, useEffect } from 'react';

export const SBOMContext = createContext({
  isGroupedByChanging: null,
  setIsGroupedByChanging: () => {},
  openDownloadSBOM: null,
  setOpenDownloadSBOM: () => {},
  openDownloadCBOM: null,
  setOpenDownloadCBOM: () => {},
  openRemoveModal: null,
  setOpenRemoveModal: () => {},
  openAddDependencyModal: null,
  setOpenAddDependencyModal: () => {},
  openEditDependencyModal: null,
  setOpenEditDependencyModal: () => {},
  selectedComponents: null,
  setSelectedComponents: () => {},
  editingComponent: null,
  setEditingComponent: () => {},
  enabledVerificationMethods: null,
  setEnabledVerificationMethods: () => {}
});

function NRSBOMDataShare({ children }) {
  const [isGroupedByChanging, setIsGroupedByChanging] = useState(false);
  const [openDownloadSBOM, setOpenDownloadSBOM] = useState(false);
  const [openDownloadCBOM, setOpenDownloadCBOM] = useState(false);
  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const [openAddDependencyModal, setOpenAddDependencyModal] = useState(false);
  const [openEditDependencyModal, setOpenEditDependencyModal] = useState(false);
  const [selectedComponents, setSelectedComponents] = useState(null);
  const [editingComponent, setEditingComponent] = useState(null);
  const [enabledVerificationMethods, setEnabledVerificationMethods] = useState({
    heuristic: true,
    cryptographicHash: true,
    packageManager: true,
    functionHashing: true,
    symbolIndex: true
  });

  useEffect(() => {
    // TODO: change this when API data is ready
    const fetchVerificationMethodSettings = async () => {
      try {
        // TODO: change this values when API data is ready
        setEnabledVerificationMethods({
          heuristic: true,
          cryptographicHash: true,
          packageManager: true,
          functionHashing: true,
          symbolIndex: true
        });
      } catch (error) {
        console.error('Error fetching verification method settings:', error);
      }
    };

    fetchVerificationMethodSettings();
  }, []);

  const defaultValues = {
    isGroupedByChanging,
    setIsGroupedByChanging,
    openDownloadSBOM,
    setOpenDownloadSBOM,
    openDownloadCBOM,
    setOpenDownloadCBOM,
    openRemoveModal,
    setOpenRemoveModal,
    openAddDependencyModal,
    setOpenAddDependencyModal,
    openEditDependencyModal,
    setOpenEditDependencyModal,
    selectedComponents,
    setSelectedComponents,
    editingComponent,
    setEditingComponent,
    enabledVerificationMethods,
    setEnabledVerificationMethods
  };
  return <SBOMContext.Provider value={defaultValues}>{children}</SBOMContext.Provider>;
}

export default NRSBOMDataShare;
